export const DATA_QA = {
  CONFIRM_BUTTON: 'disable-local-dnc-modal-confirm-button',
  CANCEL_BUTTON: 'disable-local-dnc-modal-cancel-button',
};
